import { LenderConcession } from '../../interfaces';

export const TDBank: LenderConcession = {
  lenderNameRegEx: new RegExp('TDBANK|TD BANK|TDRC|TDBNK|TD AUTO'),
  standardMinimumPercent: 2,
  minimumDollarAmount: 10,
  apr: 0,
};
